module.exports = __webpack_public_path__ + "img/download_guide_bg.4ce875de.png";